import React, { createContext, useState, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ResellerLimitDialog from './resellerLimitDialog';
import { CommonHelper } from 'src/utils/commonHelper';

export const ResellerLimitDialogContext = createContext();

export const ResellerLimitDialogProvider = ({ children }) => {
  const isReseller = CommonHelper.GetBrandInfoFromLocalStorage('is_reseller');
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage('is_portal_admin');
  const navigate = useNavigate();
  const [dialogState, setDialogState] = useState({
    open: false,
    limitType: null, // 'credit', 'social', or 'user'
    navigatePath: '/handle-reseller',
  });

  const showResellerLimitDialog = useCallback(
    (message ="", { navigatePath = '/handle-reseller' } = {}) => {
      if (!isReseller || !isPortalAdmin) return false;

      let limitType = null;
      if (message.includes('maximum limit of credit')) {
        limitType = 'credit';
      } else if (message.includes('accounts left to integrate')) {
        limitType = 'social';
      } else if (message.includes('User limit')) {
        limitType = 'user';
      }

      if (limitType) {
        setDialogState({ open: true, limitType, navigatePath });
        return true; // Dialog triggered
      }
      return false; // Conditions not met
    },
    [isReseller, isPortalAdmin]
  );

  const closeCreditLimitDialog = useCallback(() => {
    setDialogState((prev) => ({ ...prev, open: false, limitType: null }));
  }, []);

  return (
    <ResellerLimitDialogContext.Provider value={{ showResellerLimitDialog, closeCreditLimitDialog }}>
      {children}
      <ResellerLimitDialog
        open={dialogState.open}
        onClose={closeCreditLimitDialog}
        limitType={dialogState.limitType}
        navigatePath={dialogState.navigatePath}
        navigate={navigate}
      />
    </ResellerLimitDialogContext.Provider>
  );
};

export const useResellerLimitDialog = () => useContext(ResellerLimitDialogContext);